// Portfolio project data for Coding Solutions
// Images are served from /assets/ (public folder).

export const PROJECTS = [
  {
    id: "joyfill",
    title: "Joyfill Germany",
    url: "https://joyfill.de/",
    industry: "Baby Products",
    tech: "Shopify",
    category: "shopify",
    description:
      "Premium ecommerce experience focused on conversions and trust for a German baby-products brand.",
    image: "/assets/Joyfill.png",
    accent: "from-rose-400/30 to-orange-400/20",
  },
  {
    id: "thomsen",
    title: "Thomsen Germany",
    url: "https://www.thomsen-germany.de/",
    industry: "Lifestyle",
    tech: "Shopify",
    category: "shopify",
    description:
      "Refined Shopify storefront engineered for product storytelling and seamless checkout.",
    image: "/assets/Thomsen.png",
    accent: "from-blue-500/30 to-cyan-400/20",
  },
  {
    id: "soulbaby",
    title: "SoulBaby Germany",
    url: "https://soulbaby.de/",
    industry: "Baby & Maternity",
    tech: "Shopify",
    category: "shopify",
    description:
      "Soft, emotive D2C experience built for organic baby essentials with high CRO focus.",
    image: "/assets/SoulBaby.png",
    accent: "from-pink-400/30 to-violet-400/20",
  },
  {
    id: "luxe",
    title: "The Luxe Attire",
    url: "https://theluxeattire.com/",
    industry: "Luxury Fashion",
    tech: "Shopify",
    category: "shopify",
    description:
      "Editorial luxury fashion storefront with refined typography and high-conversion product pages.",
    image: "/assets/The Luxe Attire.png",
    accent: "from-amber-400/30 to-rose-400/20",
  },
  {
    id: "drinkshift",
    title: "Drink Shift",
    url: "https://drinkshift.in/",
    industry: "Beverage",
    tech: "Shopify",
    category: "shopify",
    description:
      "Vibrant D2C beverage experience built on Shopify with full subscription support.",
    image: "/assets/Drinkshift.png",
    accent: "from-emerald-400/30 to-teal-400/20",
  },
  {
    id: "tailorjunction",
    title: "Tailor Junction",
    url: "https://tailorjunction.com/",
    industry: "Bespoke Tailoring",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Bespoke tailoring brand site with custom WooCommerce flows and rich content.",
    image: "/assets/Tailorjunction.png",
    accent: "from-indigo-400/30 to-blue-400/20",
  },
  {
    id: "arn",
    title: "ARN Holidays",
    url: "https://arnholidays.com/",
    industry: "Travel",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Premium travel website with destination storytelling and itinerary builder.",
    image: "/assets/ARN Holidays.png",
    accent: "from-sky-400/30 to-blue-500/20",
  },
  {
    id: "traveltailorz",
    title: "The Travel Tailorz",
    url: "https://thetraveltailorz.com/",
    industry: "Travel",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Curated travel-experience platform with elegant journey planning interface.",
    image: "/assets/Travel Tailorz.png",
    accent: "from-cyan-400/30 to-blue-500/20",
  },
  {
    id: "weddingasia",
    title: "Wedding Asia",
    url: "https://weddingasiaofficial.com/",
    industry: "Weddings & Events",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Glamorous wedding-industry magazine site with cinematic editorial layout.",
    image: "/assets/Wedding Asia.png",
    accent: "from-fuchsia-400/30 to-rose-400/20",
  },
  {
    id: "varsity",
    title: "Varsity Skin Wellness",
    url: "https://varsityskinwellness.com/",
    industry: "Wellness & Beauty",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Calm, premium wellness clinic site with booking and treatment catalog.",
    image: "/assets/Varsityskinwellness.png",
    accent: "from-emerald-300/30 to-teal-400/20",
  },
  {
    id: "surbhisakshi",
    title: "Surbhi Sakshi Developers",
    url: "https://surbhisakshidevelopers.com/",
    industry: "Real Estate",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Real-estate developer portfolio with property listings and inquiry engine.",
    image: "/assets/Surbhisakshidevelopers.png",
    accent: "from-amber-400/30 to-yellow-500/20",
  },
  {
    id: "puloka",
    title: "Puloka",
    url: "https://puloka.in/",
    industry: "Lifestyle",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Lifestyle brand site with content-rich storytelling and clean typography.",
    image: "/assets/Puloka.png",
    accent: "from-rose-400/30 to-pink-500/20",
  },
  {
    id: "metaleye",
    title: "Metal Eye",
    url: "https://metal-eye.com/",
    industry: "Industrial",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Industrial corporate website with engineering portfolio and quote requests.",
    image: "/assets/Metaleye.png",
    accent: "from-slate-400/30 to-zinc-500/20",
  },
  {
    id: "gsm",
    title: "GSM Mechanical",
    url: "https://gsmmechanical.com.au/",
    industry: "Engineering",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Australian mechanical-engineering site with rich service catalog.",
    image: "/assets/Gsmmechanical.png",
    accent: "from-zinc-400/30 to-slate-500/20",
  },
  {
    id: "mytripvilla",
    title: "My Trip Villa",
    url: "https://mytripvilla.com/",
    industry: "Hospitality",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Vacation rental booking site with crisp imagery and instant search.",
    image: "/assets/Mytripvilla.png",
    accent: "from-orange-300/30 to-amber-400/20",
  },
  {
    id: "beanstalk",
    title: "7 Beanstalk",
    url: "https://www.7beanstalk.no/",
    industry: "Consulting",
    tech: "WordPress",
    category: "wordpress",
    description:
      "Norwegian consultancy site with calm minimal interface and content depth.",
    image: "/assets/7beanstalk.png",
    accent: "from-green-400/30 to-emerald-500/20",
  },
  {
    id: "playtics",
    title: "Playtics",
    url: "https://playtics.net/",
    industry: "Sports Tech",
    tech: "Custom Development",
    category: "custom",
    description:
      "Sports analytics and performance platform built end-to-end as a custom web application.",
    image: "/assets/Playtics.png",
    accent: "from-blue-500/30 to-violet-500/20",
  },
];

export const FEATURED_IDS = [
  "joyfill",
  "thomsen",
  "soulbaby",
  "luxe",
  "drinkshift",
  "weddingasia",
  "tailorjunction",
  "playtics",
];

export const FEATURED_PROJECTS = FEATURED_IDS
  .map((id) => PROJECTS.find((p) => p.id === id))
  .filter(Boolean);
